export const SITE_URL = "https://vivor.tech";

export type RouteSeo = {
  title: string;
  description: string;
  image: string;
  imageAlt: string;
  pageType: "website" | "article";
  schemaName: string;
};

export const routeSeo: Record<string, RouteSeo> = {
  "/": {
    title: "Разработка сайтов и интернет-магазинов под ключ | Vivor.tech",
    description:
      "Создаю продающие лендинги, современные сайты и интернет-магазины под ключ: стратегия, UX/UI, React-разработка, GSAP-анимация, SEO, адаптив и запуск.",
    image: "/og-vivor-tech-v2.png",
    imageAlt: "Vivor.tech — лендинги, которые объясняют и ведут к заявке",
    pageType: "website",
    schemaName: "Vivor.tech — дизайн и разработка лендингов",
  },
  "/nord-79": {
    title: "NORD/79 — лендинг арктической экспедиции | Vivor.tech",
    description:
      "Интерактивный концепт лендинга исследовательской экспедиции: редакционная типографика, кинематографичный скролл и GSAP-анимация.",
    image: "/og-nord-79.jpg",
    imageAlt: "Интерактивный лендинг арктической экспедиции NORD/79",
    pageType: "article",
    schemaName: "NORD/79 — концепт лендинга арктической экспедиции",
  },
  "/sillage": {
    title: "Sillage — премиальный парфюмерный лендинг | Vivor.tech",
    description:
      "Концепт премиального парфюмерного сайта с редакционной композицией, интерактивным раскрытием аромата и e-commerce сценарием.",
    image: "/og-sillage.jpg",
    imageAlt: "Премиальный парфюмерный лендинг Sillage",
    pageType: "article",
    schemaName: "Sillage — концепт премиального парфюмерного лендинга",
  },
  "/field-os": {
    title: "FIELD/OS — лендинг агротехнологий и Data UI | Vivor.tech",
    description:
      "Интерактивный лендинг агротехнологического сервиса: карта полей, визуализация данных, калькулятор миссии и интерфейс заявки.",
    image: "/og-field-os.jpg",
    imageAlt: "Технологичный лендинг сервиса точного земледелия FIELD/OS",
    pageType: "article",
    schemaName: "FIELD/OS — концепт лендинга агротехнологического сервиса",
  },
  "/govori": {
    title: "Говори — лендинг детского логопеда | Vivor.tech",
    description:
      "Концепт дружелюбного сайта логопедического центра: понятный путь услуги, интерактивная методика, запись и адаптивный дизайн.",
    image: "/og-govori.jpg",
    imageAlt: "Современный лендинг детского логопедического центра Говори",
    pageType: "article",
    schemaName: "Говори — концепт лендинга детского логопедического центра",
  },
  "/null-field": {
    title: "NULL/FIELD — лендинг музыкального фестиваля | Vivor.tech",
    description:
      "Иммерсивный концепт фестивального сайта с программой, живым аудиовизуальным интерфейсом, выбором билетов и GSAP-анимацией.",
    image: "/og-null-field.jpg",
    imageAlt: "Иммерсивный лендинг фестиваля электронной музыки NULL/FIELD",
    pageType: "article",
    schemaName: "NULL/FIELD — концепт лендинга музыкального фестиваля",
  },
  "/sloi-store": {
    title: "SLOI — интернет-магазин с личным кабинетом и CMS | Vivor.tech",
    description:
      "Интерактивный концепт fashion e-commerce: каталог с фильтрами, корзина и checkout, личный кабинет, управление товарами, заказами, контентом и аналитикой.",
    image: "/assets/vanta/look-01.jpg",
    imageAlt: "SLOI — современный интернет-магазин брендовой одежды с открытой CMS",
    pageType: "article",
    schemaName: "SLOI — концепт интернет-магазина с личным кабинетом и CMS",
  },
};

export function normalizeRoute(pathname: string) {
  if (pathname === "/") return pathname;
  return pathname.replace(/\/+$/, "");
}

export function getRouteSeo(pathname: string) {
  const route = normalizeRoute(pathname);
  if (routeSeo[route]) return routeSeo[route];

  const categoryNames: Record<string, string> = {
    outerwear: "Верхняя одежда",
    knitwear: "Трикотаж",
    tops: "Топы",
    trousers: "Брюки",
    shoes: "Обувь",
  };
  const collectionNames: Record<string, string> = {
    women: "Женская коллекция",
    men: "Мужская коллекция",
    unisex: "Унисекс",
  };
  const categorySlug = route.match(/^\/sloi-store\/category\/([^/]+)$/)?.[1];
  const collectionSlug = route.match(/^\/sloi-store\/collection\/([^/]+)$/)?.[1];
  const storeSection = categorySlug ? categoryNames[categorySlug] : collectionSlug ? collectionNames[collectionSlug] : undefined;
  if (storeSection) {
    return {
      ...routeSeo["/sloi-store"],
      title: `${storeSection} — каталог одежды SLOI | Vivor.tech`,
      description: `${storeSection} в интернет-магазине SLOI: фильтры по бренду, размеру и цене, живые SKU-остатки, корзина и оформление заказа.`,
      schemaName: `${storeSection} — каталог интернет-магазина SLOI`,
    };
  }
  if (route === "/sloi-store/account") {
    return { ...routeSeo["/sloi-store"], title: "Личный кабинет SLOI | Vivor.tech", schemaName: "Личный кабинет интернет-магазина SLOI" };
  }
  if (route === "/sloi-store/admin") {
    return { ...routeSeo["/sloi-store"], title: "SLOI Studio — демо CMS интернет-магазина | Vivor.tech", schemaName: "SLOI Studio — CMS интернет-магазина" };
  }
  return routeSeo["/"];
}

export function getCanonicalUrl(pathname: string) {
  const route = normalizeRoute(pathname);
  return route === "/" ? `${SITE_URL}/` : `${SITE_URL}${route}`;
}

export function createRouteSchema(pathname: string, seo: RouteSeo) {
  const route = normalizeRoute(pathname);
  const canonical = getCanonicalUrl(route);
  const absoluteImage = `${SITE_URL}${seo.image}`;

  if (route === "/") {
    return {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebSite",
          "@id": `${SITE_URL}/#website`,
          url: `${SITE_URL}/`,
          name: "Vivor.tech",
          alternateName: "Vivor",
          inLanguage: "ru-RU",
          description: seo.description,
        },
        {
          "@type": "Person",
          "@id": `${SITE_URL}/#vivor`,
          name: "Vivor",
          alternateName: "Vivor.tech",
          url: `${SITE_URL}/`,
          image: `${SITE_URL}/favicon-512.png`,
          email: "mailto:info@vivor.tech",
          jobTitle: "Веб-разработчик и дизайнер лендингов",
          sameAs: ["https://t.me/MrVivor"],
          knowsAbout: [
            "Разработка лендингов",
            "Веб-дизайн",
            "React",
            "TypeScript",
            "GSAP-анимация",
            "Адаптивная вёрстка",
            "Техническая SEO-оптимизация",
          ],
        },
        {
          "@type": "Service",
          "@id": `${SITE_URL}/#landing-development`,
          name: "Разработка продающих лендингов под ключ",
          serviceType: "Дизайн и разработка лендингов и промосайтов",
          description: seo.description,
          url: `${SITE_URL}/`,
          provider: { "@id": `${SITE_URL}/#vivor` },
          areaServed: "Worldwide",
          availableLanguage: "Russian",
        },
        {
          "@type": "ImageObject",
          "@id": `${SITE_URL}/#primaryimage`,
          contentUrl: absoluteImage,
          caption: seo.imageAlt,
        },
      ],
    };
  }

  return {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "@id": `${canonical}#webpage`,
    url: canonical,
    name: seo.schemaName,
    headline: seo.title,
    description: seo.description,
    inLanguage: "ru-RU",
    isPartOf: { "@id": `${SITE_URL}/#website` },
    author: { "@id": `${SITE_URL}/#vivor` },
    primaryImageOfPage: {
      "@type": "ImageObject",
      contentUrl: absoluteImage,
      caption: seo.imageAlt,
    },
  };
}
